import { LazyAction, LazyModule } from 'owa-bundling';
// export action names and types
export { default as mailStore, getStore } from './store/Store';
export { default as InstrumentationContext } from './store/schema/InstrumentationContext';
export { default as FrequentlyUsedFolder } from './store/schema/FrequentlyUsedFolder';
export { default as ActionSource } from './store/schema/ActionSource';
export { default as ConversationItemParts } from './store/schema/ConversationItemParts';
export { default as ConversationReadingPaneNode } from './store/schema/ConversationReadingPaneNode';
export { default as SmartReplyData } from './store/schema/SmartReplyData';
export { default as TailoredXpData } from './store/schema/TailoredXpData';
export { default as CollectionChange } from './store/schema/CollectionChange';
export { LocalLieState } from './store/schema/LocalLieState';
export { default as MailListItemSelectionSource } from './store/schema/MailListItemSelectionSource';
export {
    FindConversationShapeName,
    getFindConversationShape,
} from './services/utils/findConversationShapeUtil';
export { getFindItemShape } from './services/utils/findItemShapeUtil';
export {
    default as findConversationWithStartIndex,
    FindConversationOperationEndLabel,
    FindConversationOperationStartLabel,
} from './services/findConversationWithStartIndex';
export { default as findItemWithStartIndex } from './services/findItemWithStartIndex';
export { default as getItem } from './services/getItem';
export { default as getConversationFromNodes } from './utils/getConversationFromNodes';
export { default as getConversationItemsService } from './services/getConversationItemsService';
export { default as loadTailoredXpData } from './services/loadTailoredXpData';
export { default as selectMailStoreItemById } from './selectors/selectMailStoreItemById';
export { default as conversationCache } from './store/conversationCache';
export { default as checkIfResponseSuccess } from './services/utils/checkIfResponseSuccess';
export {
    getComposeItemResponseShape,
    getBaseItemResponseShape,
    getConversationItemResponseShape,
    configItemResponseShapeForCLP,
} from './utils/getItemResponseShape';
export { default as isValidMailFolder } from './utils/isValidMailFolder';
export { default as ClientItem } from './store/schema/ClientItem';
export { default as ClientMessage } from './store/schema/ClientMessage';
export { default as SmartTaskData } from './store/schema/SmartTaskData';
export { default as SmartTaskSuggestion } from './store/schema/SmartTaskSuggestion';
export { default as SmartTimeData } from './store/schema/SmartTimeData';
export { default as SmartTimeSuggestion } from './store/schema/SmartTimeSuggestion';
export { default as SmartTimeExtendedProperty } from './store/schema/SmartTimeExtendedProperty';
export { default as isFolderUnderArchiveRoot } from './utils/isFolderUnderArchiveRoot';
export { isFolderOrSubFolderOfArchiveRoot } from './utils/isFolderUnderArchiveRoot';
export {
    default as isFolderUnderDeletedItemsFolder,
} from './utils/isFolderUnderDeletedItemsFolder';
export {
    default as isDeletedItemsFolderFromAnyMailbox,
} from './utils/isDeletedItemsFolderFromAnyMailbox';
export { default as isDumpsterFolderFromAnyMailbox } from './utils/isDumpsterFolderFromAnyMailbox';
export {
    default as isUnderDeletedItemsFolderFromAnyMailbox,
} from './utils/isUnderDeletedItemsFolderFromAnyMailbox';
export { default as getSelectedFolder } from './utils/getSelectedFolder';
export {
    getUserPermissionForFolderId,
    getUserPermissionForFolderIdWithErr,
} from './utils/getUserPermissionForFolderId';
export {
    AttachmentSuggestions,
    ReplyWithAttachmentSuggestion,
    ReplyWithEndpointType,
} from './store/schema/AttachmentSuggestions';
export { default as StampedLanguage } from './store/schema/StampedLanguage';
export { default as isShowFullEmailForEnterprise } from './utils/isShowFullEmailForEnterprise';
export {
    default as PendingConversationRequestState,
} from './store/schema/PendingConversationRequestState';
export {
    default as LoadConversationItemActionSource,
} from './store/schema/LoadConversationItemActionSource';
export { default as LoadingState } from './store/schema/LoadingState';
export { default as setIsDraftQueuedForSubmission } from './actions/setIsDraftQueuedForSubmission';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "mailStore" */ './lazyIndex'));

export let lazyFindConversationWithSeekToDateTimeCondition = new LazyAction(
    lazyModule,
    m => m.findConversationWithSeekToDateTimeCondition
);

export let lazyFindConversationEqualToConversationId = new LazyAction(
    lazyModule,
    m => m.findConversationEqualToConversationId
);
